export const QUERY_KEY_DOCUMENT = 'document'

export const DOCUMENT_LIST_QUERY_KEY = (params?: (string | number)[]) =>
  ['document-set-list', ...(params || [])] as const

export const DOCUMENT_RETRIEVAL_QUERY_KEY = (params: string) =>
  [`${QUERY_KEY_DOCUMENT}-retrieval`, ...params] as const

export const DOCUMENT_VERSION_QUERY_KEY = (params?: (string | number)[]) =>
  [QUERY_KEY_DOCUMENT, 'version', ...(params || [])] as const

export const DOCUMENT_VERSION_LIST_QUERY_KEY = (params?: (string | number)[]) =>
  [QUERY_KEY_DOCUMENT, 'version-list', ...(params || [])] as const
